import _ from 'underscore';

const canSelectNode = node => !(node.state && node.state.disabled);

const selectChildNodes = (nodes, checked, skipDisabled = false) =>
  nodes.map((n) => {
    let node = n;

    // Only select the node if it can be selected or skipDisabled is false
    if (!skipDisabled || canSelectNode(node)) {
      node = _.extend(node, {
        children: node.children ? selectChildNodes(node.children, checked, skipDisabled) : [],
        state: _.extend(node.state || {}, { checked, indeterminate: false }),
      });
    }
    return node;
  });

const setParentNodeWithPartialSelectionState = (parentNode) => {
  const pNode = parentNode;

  if (parentNode && parentNode.children && parentNode.state) {
    let { checked } = parentNode.state;
    let checkedChildNodes = false;
    let unCheckedChildNodes = false;

    parentNode.children.forEach((node) => {
      checked = checked && node.state && node.state.checked;
      checkedChildNodes = checkedChildNodes
        || (node.state && node.state.checked);
      unCheckedChildNodes = unCheckedChildNodes
        || !(node.state && node.state.checked);
    });
    pNode.state.checked = checked;
  }
};

const setParentNodeSelectedState = (parentNode, skipDisabled = false) => {
  const pNode = parentNode;

  if (parentNode && parentNode.children && parentNode.state) {
    let checked = true;
    let checkedChildNodes = false;
    let unCheckedChildNodes = false;
    let indeterminateChildNodes = false;

    parentNode.children.forEach((node) => {
      // Only consider the node if it can be selected or skipDisabled is false
      if (!skipDisabled || canSelectNode(node)) {
        checked = checked && node.state && node.state.checked;
        indeterminateChildNodes = indeterminateChildNodes || (node.state && node.state.indeterminate);
        checkedChildNodes = checkedChildNodes || (node.state && node.state.checked);
        unCheckedChildNodes = unCheckedChildNodes || !(node.state && node.state.checked);
      }
    });
    pNode.state.checked = checked;
    pNode.state.indeterminate = indeterminateChildNodes ||
      (checkedChildNodes && unCheckedChildNodes);
  }
};

export const NodeSelectedHandlerWithPartialSelection = (nodes, node) => {
  const selectedNodes = nodes.map((n) => {
    if (n.id === node.id) {
      return _.extend(node, {
        children: n.children ? selectChildNodes(n.children, node.state.checked) : [],
      });
    }
    if (n.children) {
      return _.extend(n, {
        children: NodeSelectedHandlerWithPartialSelection(n.children, node),
      });
    }

    return n;
  });

  if (node.parents) {
    node.parents.reverse().forEach((p) => {
      setParentNodeWithPartialSelectionState(_.find(selectedNodes, n => n.id === p));
    });
  }
  return selectedNodes;
};

export const NodeSelectedHandler = (nodes, node, skipDisabled = false) => {
  const selectedNodes = nodes.map((n) => {
    if (n.id === node.id) {
      return _.extend(node, {
        children: n.children ? selectChildNodes(n.children, node.state.checked, skipDisabled) : [],
      });
    }
    if (n.children) {
      return _.extend(n, {
        children: NodeSelectedHandler(n.children, node, skipDisabled),
      });
    }

    return n;
  });

  if (node.parents) {
    node.parents.reverse().forEach((p) => {
      setParentNodeSelectedState(_.find(selectedNodes, n => n.id === p), skipDisabled);
    });
  }
  return selectedNodes;
};

export const NodeSelectedHandlerSkipDisabled = (nodes, node) => NodeSelectedHandler(nodes, node, true);
